var _circle, _ellipse, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8LinkedinCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 23,
    fill: "#9c34c2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 19,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,14c2.577,0,4.674-1.957,4.946-4.461C35.352,9.19,33.699,9,32,9 C19.297,9,9,19.297,9,32c0,1.699,0.19,3.352,0.539,4.946C12.044,36.674,14,34.577,14,32C14,22.075,22.075,14,32,14z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M15.047,23.427c1.878-3.699,4.932-6.705,8.666-8.522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.461,27.054C51.956,27.326,50,29.423,50,32c0,9.925-8.075,18-18,18 c-2.577,0-4.674,1.957-4.946,4.461C28.648,54.81,30.301,55,32,55c12.703,0,23-10.297,23-23C55,30.301,54.81,28.648,54.461,27.054z",
    opacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a0effe",
    d: "M21.321,27.071h3.286c0.454,0,0.821,0.368,0.821,0.821v14.786c0,0.454-0.368,0.821-0.821,0.821 h-3.286c-0.454,0-0.821-0.368-0.821-0.821V27.893C20.5,27.439,20.868,27.071,21.321,27.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0effe",
    d: "M22.95,25.429h-0.028c-1.471,0-2.422-1.096-2.422-2.465c0-1.399,0.981-2.463,2.478-2.463 c1.499,0,2.423,1.065,2.45,2.463C25.429,24.331,24.477,25.429,22.95,25.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0effe",
    d: "M39.393,43.5c-0.454,0-0.821-0.368-0.821-0.821V34.78c0-2.106-1.174-3.544-3.059-3.544 c-1.438,0-2.217,0.97-2.594,1.907c-0.138,0.335-0.097,1.263-0.097,1.732v7.804c0,0.454-0.368,0.821-0.821,0.821h-3.286 c-0.454,0-0.821-0.368-0.821-0.821V27.893c0-0.454,0.368-0.821,0.821-0.821H32c0.454,0,0.821,0.368,0.821,0.821v1.643 c0.691-1.07,1.91-2.469,4.677-2.469c3.429,0,6,2.298,6,7.112l0.001,8.499c0,0.454-0.368,0.822-0.821,0.822H39.393z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LinkedinCircled);
export default __webpack_public_path__ + "static/media/icons8-linkedin-circled.36f7b461723eb1d2c694eb57ae6f18b2.svg";
export { ForwardRef as ReactComponent };